function parseTimeToMilliseconds(timeString: string) {
  if (!timeString) return -1

  const [hours, minutes, secondsAndMilliseconds] = timeString.split(":")
  if (!secondsAndMilliseconds) return -1 // this isn't a valid timestamp
  const [seconds, milliseconds] = secondsAndMilliseconds.split(",")
  return (
    parseInt(hours, 10) * 3600000 + // hours to milliseconds
    parseInt(minutes, 10) * 60000 + // minutes to milliseconds
    parseInt(seconds, 10) * 1000 + // seconds to milliseconds
    parseInt(milliseconds, 10) // milliseconds
  )
}

export function parseSrt(srt: string) {
  if (!srt) return []
  // Normalize line endings to Unix style, then split the content based on a blank line.
  const entries = srt.replace(/\r\n/g, "\n").trim().split(/\n\n+/)

  return entries
    .map((entry) => {
      if (!entry) return null
      const lines = entry.split("\n")
      // Attempt to parse the index, which should be the first line.
      const index = parseInt(lines[0], 10)
      // The time codes should be on the first or second line, depending on the index's presence.
      const timeLineIndex = isNaN(index) ? 0 : 1
      const times = lines[timeLineIndex]
        .split(" --> ")
        .map((time) => time.trim())
      const start = parseTimeToMilliseconds(times[0])
      const end = parseTimeToMilliseconds(times[1])
      // The subtitle text starts after the time codes.
      const textStartIndex = timeLineIndex + 1
      const text = lines.slice(textStartIndex).join("\n").trim()

      return { start, end, text }
    })
    .filter((entry) => entry !== null) as {
    start: number
    end: number
    text: string
  }[]
}
